module.exports = __webpack_public_path__ + "static/img/section02-02@t.a7755e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/samsung-svc/section02-02@t.jpg
// module id = 8/jd
// module chunks = 0